import { Input, Select } from "components/base/Form";
import FactorySelector from "components/shared/FactorySelector";
import ItemSizeInput from "components/shared/ItemSizeInput";
import { useContext } from "react";
import { ProductContext } from "./ProductForm";

const BaseInfoView = () => {
  const { product, setProduct } = useContext(ProductContext);

  return (
    <div className="card">
      <h5>Base Info</h5>
      <div className="mt-2 -mx-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>Name: </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={product.name}
                  onChange={(e) =>
                    setProduct((prev) => ({ ...prev, name: e.target.value }))
                  }
                  placeholder="For example: EU Surf ball in 2 tier box assorted color."
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Name CN: </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={product.nameCn}
                  onChange={(e) =>
                    setProduct((prev) => ({ ...prev, nameCn: e.target.value }))
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Item Number: </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  validated={!/\s/.test(product.number || "")}
                  value={product.number}
                  onChange={(e) =>
                    setProduct((prev) => ({ ...prev, number: e.target.value }))
                  }
                  placeholder="Same value as Internal Reference / default code in Odoo."
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Country of Origin: </label>
              </td>
              <td>
                <Select
                  className="w-full"
                  value={product.countryCodeOfOrigin || ""}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      countryCodeOfOrigin: e.target.value || null,
                    }))
                  }
                >
                  <option value="">-- Select --</option>
                  <option value="CN">China</option>
                  <option value="KH">Cambodia</option>
                </Select>
              </td>
            </tr>
            <tr>
              <td>
                <label>Version: </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={product.version}
                  onChange={(e) =>
                    setProduct((prev) => ({ ...prev, version: e.target.value }))
                  }
                  placeholder="1.0"
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Item Size(mm): </label>
              </td>
              <td>
                <ItemSizeInput
                  value={product.size}
                  onChange={(size) => setProduct((prev) => ({ ...prev, size }))}
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Item Weight(g): </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={product.itemWeight}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      itemWeight: e.target.value,
                    }))
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Gross Weight(g): </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={product.grossWeight}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      grossWeight: e.target.value,
                    }))
                  }
                />
              </td>
            </tr>

            <tr>
              <td className="align-baseline">
                <label>Materials: </label>
              </td>
              <td className="align-baseline">
                <Input
                  className="w-full"
                  value={product.productMaterial}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      productMaterial: e.target.value,
                    }))
                  }
                  placeholder="For example:
                  350G白心单粉+4C+哑油+PET吸塑油, K636K, 0.5pet+中间开孔, etc."
                />
                <div className=" opacity-70 m-1 text-xs">
                  This field is used to store the material information for the
                  product(most for component, 材质要求). It is different from
                  the product line materials.
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <label>Default Supplier: </label>
              </td>
              <td>
                <FactorySelector
                  value={product.defaultSupplierId}
                  onChange={(defaultSupplierId) =>
                    setProduct((prev) => ({ ...prev, defaultSupplierId }))
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Producer: </label>
              </td>
              <td>
                <FactorySelector
                  value={product.producerId}
                  onChange={(producerId) =>
                    setProduct((prev) => ({ ...prev, producerId }))
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Deliver to: </label>
              </td>
              <td>
                <FactorySelector
                  value={product.deliverToSupplierId}
                  onChange={(deliverToSupplierId) =>
                    setProduct((prev) => ({ ...prev, deliverToSupplierId }))
                  }
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Default Sales Qty: </label>
              </td>
              <td>
                <Input
                  className="text-center"
                  value={product.defaultQty}
                  onChange={(e) =>
                    setProduct((prev) => ({
                      ...prev,
                      defaultQty: e.target.value,
                    }))
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>MOQ: </label>
              </td>
              <td>
                <Input
                  className="text-center"
                  value={product.moq}
                  onChange={(e) =>
                    setProduct((prev) => ({ ...prev, moq: e.target.value }))
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BaseInfoView;
